import React, { useState } from 'react';
import { Pagination, Form, InputGroup, Button } from "react-bootstrap";
import './styles/Pages.css';

const Pages = ({ totalCount, page, setPage, limit }) => {
    const [jumpPage, setJumpPage] = useState('');
    const pageCount = Math.ceil(totalCount / limit);
    if (pageCount <= 1) return null;
    const pages = [];
    let start = 1;
    let end = pageCount;
    if (pageCount > 5) {
        if (page <= 3) {
            start = 1;
            end = 5;
        } else if (page >= pageCount - 2) {
            start = pageCount - 4;
            end = pageCount;
        } else {
            start = page - 2;
            end = page + 2;
        }
    }
    for (let i = start; i <= end; i++) {
        pages.push(i);
    }
    const handleJump = (e) => {
        e.preventDefault();
        const num = Number(jumpPage);
        if (num >= 1 && num <= pageCount) {
            setPage(num);
            setJumpPage('');
        }
    };
    return (
        <div className="pagination-fixed-bar fade-in-pagination" aria-label="Пагинация">
            <div className="pagination-info mb-2 text-center">
                <span>Страниц: {pageCount}, товаров: {totalCount}</span>
            </div>
            <Pagination className="custom-pagination" aria-label="Навигация по страницам">
                <Pagination.Prev
                    onClick={() => setPage(page - 1)}
                    disabled={page === 1}
                    aria-label="Назад"
                >Назад</Pagination.Prev>
                {start > 1 && (
                    <>
                        <Pagination.Item onClick={() => setPage(1)} active={page === 1}>1</Pagination.Item>
                        {start > 2 && <Pagination.Ellipsis disabled />}
                    </>
                )}
                {pages.map(pageNumber => (
                    <Pagination.Item
                        key={pageNumber}
                        active={page === pageNumber}
                        onClick={() => setPage(pageNumber)}
                        aria-label={`Страница ${pageNumber}`}
                    >
                        {pageNumber}
                    </Pagination.Item>
                ))}
                {end < pageCount && (
                    <>
                        {end < pageCount - 1 && <Pagination.Ellipsis disabled />}
                        <Pagination.Item onClick={() => setPage(pageCount)} active={page === pageCount}>{pageCount}</Pagination.Item>
                    </>
                )}
                <Pagination.Next
                    onClick={() => setPage(page + 1)}
                    disabled={page === pageCount}
                    aria-label="Вперёд"
                >Вперёд</Pagination.Next>
            </Pagination>
            <form className="quick-jump-form mt-2 d-flex justify-content-center" onSubmit={handleJump} aria-label="Быстрый переход к странице">
                <InputGroup style={{ maxWidth: 160 }}>
                    <Form.Control
                        type="number"
                        min={1}
                        max={pageCount}
                        value={jumpPage}
                        onChange={e => setJumpPage(e.target.value.replace(/[^0-9]/g, ''))}
                        placeholder="Стр. №"
                        aria-label="Введите номер страницы"
                    />
                    <Button type="submit" variant="outline-primary" disabled={!jumpPage || Number(jumpPage) < 1 || Number(jumpPage) > pageCount}>Перейти</Button>
                </InputGroup>
            </form>
        </div>
    );
};

export default Pages;